// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-drawing-container {
  height: calc(100vh - 93px);
  position: relative;
}

::ng-deep .canvas-container {
  margin: 0 auto;
}

:host ::ng-deep .ng2-pdf-viewer-container .annotationLayer {
  position: absolute;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/app/common/pdf-drawing/pdf-drawing.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAGA;EACI,kBAAA;EACA,WAAA;AAAJ","sourcesContent":[".pdf-drawing-container {\n    height: calc(100vh - 93px);\n    position: relative;\n}\n\n::ng-deep .canvas-container {\n    margin: 0 auto;\n    //z-index: 10\n}\n\n:host ::ng-deep .ng2-pdf-viewer-container .annotationLayer {\n    position: absolute;\n    z-index: 10;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
